import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import audioMp3 from "../assets/img/secret/audio.mp3";
import grannyImg from "../assets/img/secret/g1.gif";

export default function SecretPage() {
  const [loading, setLoading] = useState(true);
  let audio = new Audio(audioMp3)

  useEffect(() => {
    const starshine = document.getElementById("starshine");
    if (!starshine) return;

    const sparkle = 20;
    const stars = 500;
    const sizes = ["small", "medium", "large"];

    for (let i = 0; i < stars; i++) {
      const shine = document.createElement("div");
      shine.classList.add("shine", sizes[i % 3]);
      shine.style.top = `${Math.random() * 100}%`;
      shine.style.left = `${Math.random() * 100}%`;
      shine.style.animationDelay = `${Math.random() * sparkle}s`;
      starshine.appendChild(shine);
    }

    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const audio = document.getElementById("background-audio");
    if (audio) audio.volume = 0.5;
  }, []);

  const handlePlay = () => {
    if (audio) {
      document.getElementById("secret").classList.add("jeje");
      audio.loop = true;
      audio.play();
    }
  };

  const imgList = Array.from({ length: 15 }, (_, i) => i + 1);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>????</title>
        </Helmet>
      </HelmetProvider>
      <div id="secret">
        <audio id="background-audio"><source src={audio} type="audio/mp3" /></audio>
        <button id="btn" onClick={handlePlay}>Auto destrucción</button>
        {loading && (
          <div id="loader-secret">
            <span className="skull">💀</span>
          </div>
        )}
        <div id="starshine">
          <div className="template shine"></div>
        </div>
        <div className="content-main">
          {imgList.map((n, idx) => (
            <img key={n} alt={`Imagen secreta ${n}`} className={idx % 2 === 0 ? "left" : "right"} src={`${process.env.PUBLIC_URL}/img/secret/t${n}.gif`} />
          ))}
        </div>
        <img alt="Personaje secreto" className="paqui" src={grannyImg} />
      </div>
    </>
  );
}
